var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 471.9 100",
    viewBox: "0 0 471.9 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55 15.9c3.1-3.7 5.3-8.8 5.3-13.9 0-0.7-0.1-1.4-0.2-2-5 0.2-11 3.3-14.6 7.6-2.8 3.2-5.5 8.3-5.5 13.4 0 0.8 0.1 1.5 0.2 1.8 0.3 0.1 0.8 0.1 1.3 0.1 4.6 0 10.2-3 13.5-7zm3.6 8.1c-7.5 0-13.6 4.5-17.5 4.5-4.2 0-9.6-4.3-16.1-4.3-12.4 0.1-25 10.3-25 29.6 0 12 4.6 24.7 10.4 32.9 4.9 6.9 9.2 12.6 15.4 12.6 6.1 0 8.8-4.1 16.5-4.1 7.8 0 9.5 4 16.3 4 6.7 0 11.2-6.1 15.4-12.2 4.7-7 6.7-13.8 6.8-14.1-0.4-0.1-13.3-5.4-13.3-20.1 0-12.7 10.1-18.4 10.7-18.9-6.6-9.6-16.8-9.9-19.6-9.9z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m118.3 20.9c4.5 0 8.1-3.6 8.1-7.9 0-4.4-3.5-8-8.1-8-4.5 0-8.1 3.6-8.1 8 0.1 4.3 3.6 7.9 8.1 7.9zm-6.9 77.8h13.8v-67.4h-13.8v67.4z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m137.3 98.7h14.3v-31.6h20.1c18.1 0 30.7-12.4 30.7-30.4v-0.1c0-18.1-12.6-30.3-30.7-30.3h-34.4v92.4zm30.8-80.4c12.5 0 19.7 6.7 19.7 18.3v0.1c0 11.6-7.2 18.3-19.7 18.3h-16.5v-36.7h16.5z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m209.8 98.7h13.8v-39c0-10.5 6.3-17.8 15.9-17.8 9.7 0 15.4 6.7 15.4 17.8v39h13.8v-41.7c0-16.3-9.5-27-23.9-27-10.1 0-17.3 4.5-20.9 12.4h-0.3v-36.2h-13.8v92.5z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m307.2 100c19.3 0 32-13.3 32-35v-0.1c0-21.6-12.8-34.8-32-34.8s-31.9 13.3-31.9 34.8v0.1c-0.1 21.6 12.5 35 31.9 35zm0-11.6c-10.8 0-17.9-8.5-17.9-23.4v-0.1c0-14.7 7.1-23.3 17.7-23.3 10.8 0 17.9 8.5 17.9 23.3v0.1c0.1 14.8-6.8 23.4-17.7 23.4z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9,98.7h13.8V59.4c0-10.5,6.3-17.6,16-17.6  c9.6,0,14.3,5.7,14.3,15.8v41H404V55c0-15.5-8.5-25-23.3-25c-10.2,0-17.1,4.6-20.6,11.5h-0.3V31.3h-13.8V98.7z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m442.1 100c16.3 0 26.7-9.7 28.9-20.4l0.1-0.7h-13.1l-0.2 0.5c-1.7 5.1-7.2 9.3-15.4 9.3-11 0-18-7.4-18.3-20.2h47.7v-4.7c0-20.2-11.6-33.8-30.5-33.8s-31.1 14.1-31.1 35.2v0.1c0.2 21.2 12.2 34.7 31.9 34.7zm-0.6-58.7c9 0 15.6 5.7 16.7 17.4h-33.8c1.2-11.3 8.1-17.4 17.1-17.4z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhone);
export default __webpack_public_path__ + "static/media/iPhone.464d3c5fa9902d2cdeb22ca3d16f50cb.svg";
export { ForwardRef as ReactComponent };